import { BuilderOutput, Issue, TabId } from './types';

// Position of each tab in the visualization editor, keyed by the id the KPI Builder uses for it.
export const BUILDER_TAB_INDEX: Record<TabId, number> = { info: 0, data: 1, filters: 2, display: 3, access: 4, dashboards: 5 };

/** Whether the tab at this position has a builder warning. */
export const tabHasBuilderIssue = (issues: Issue[], idx: number): boolean => issues.some((i) => BUILDER_TAB_INDEX[i.tab] === idx);

/** What the builder adds to the saved visualization: its backend handler and its drill-down list. In builder mode a recipe with no handler clears any saved one, so a stale handler cannot change how a different recipe is processed. */
export function builderSaveExtras(builderMode: boolean, output: BuilderOutput | null, savedHandler?: string) {
  return {
    handlerKey: builderMode ? output?.handlerKey : savedHandler,
    list: builderMode ? output?.detail : undefined,
  };
}
